"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySubscriptionListResDTO = void 0;
class CompanySubscriptionListResDTO {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        this._id = String((_a = data === null || data === void 0 ? void 0 : data._id) !== null && _a !== void 0 ? _a : "");
        this.subscriptionId = data.subscriptionId;
        this.companyId = data.companyId;
        this.createdAt = data.createdAt;
        this.status = data.status;
        this.onTrial = data.onTrial;
        this.expiresAt = data.expiresAt;
        this.trialExpiresAt = data.trialExpiresAt;
        this.canceledAt = data.canceledAt;
        this.updatedAt = data.updatedAt;
        this.providerProductId = data.providerProductId;
        this.extensionPackages = data.extensionPackages;
        this.requires3DSecureConfirmation = data.requires3DSecureConfirmation;
        this.threeDomainSecureFinalized = data.threeDomainSecureFinalized;
        this.client_secret = data.client_secret || null;
        this.priceAfterDiscount = null;
        this.cancelAtPeriodEnd = (_b = data.cancelAtPeriodEnd) !== null && _b !== void 0 ? _b : false;
        this.currentPeriodStart = (_c = data.currentPeriodStart) !== null && _c !== void 0 ? _c : null;
        this.currentPeriodEnd = (_d = data.currentPeriodEnd) !== null && _d !== void 0 ? _d : null;
        this.priceProfileKey = (_e = data.priceProfileKey) !== null && _e !== void 0 ? _e : null;
        this.priceSnapshot = (_f = data.priceSnapshot) !== null && _f !== void 0 ? _f : null;
        this.fixedPriceMinorUnits = (_g = data.fixedPriceMinorUnits) !== null && _g !== void 0 ? _g : null;
        this.usageFirstTierMinorUnits = (_h = data.usageFirstTierMinorUnits) !== null && _h !== void 0 ? _h : null;
        this.subscriptionInterval = (_j = data.subscriptionInterval) !== null && _j !== void 0 ? _j : null;
        this.currency = (_k = data.currency) !== null && _k !== void 0 ? _k : null;
        this.paymentsPricingMode = (_l = data.paymentsPricingMode) !== null && _l !== void 0 ? _l : null;
        this.monthlyFeeMinor = (_m = data.monthlyFeeMinor) !== null && _m !== void 0 ? _m : null;
        this.feeSchedules = (_o = data.feeSchedules) !== null && _o !== void 0 ? _o : [];
        this.billingProviders = (_p = data.billingProviders) !== null && _p !== void 0 ? _p : [];
        this.enabledPaymentCurrencies = (_q = data.enabledPaymentCurrencies) !== null && _q !== void 0 ? _q : null;
        this.subscriptionDiscount = (_r = data.subscriptionDiscount) !== null && _r !== void 0 ? _r : null;
        this.usageBuckets = (_s = data.usageBuckets) !== null && _s !== void 0 ? _s : null;
    }
}
exports.CompanySubscriptionListResDTO = CompanySubscriptionListResDTO;
